export default __webpack_public_path__ + "static/media/Mobile Icons_1 copy 6.e4337fb7.svg";